<template>
  <user-center-wrap>
    <div class="focus-list">
      <div class="information_bottom focus-item"></div>
      <div class="title">我的关注</div>
      <div class="focus_num">您关注了{{ list.length }}个主播</div>
      <ul class="focus_c" v-if="list.length">
        <li v-for="item in list" :key="item.id">
          <img :src="item.anchor.avatar" alt="" @click="jionRoom(item)" />
          <div>
            <span class="left">{{ item.anchor.nick_name }}</span>
            <span class="right" @click="cancleFocus(item)">取消关注</span>
          </div>
        </li>
      </ul>
      <div v-else class="no-data">
        <img src="./img/noGuanzhu.png" alt="" />
        <div>您还未关注任何主播</div>
      </div>
    </div>
  </user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import LiveItem from "../../components/live-item/live-item";
import CenterCommon from "../../components/center-common/center-common";
import { post } from "../../util/http";
import { h5Host } from "../../util/host";
import getPlatform from "../../util/platform";

const PAGE_SIZE = 9;

export default {
  async asyncData({ req, redirect }) {
    if (req && process.server && getPlatform(req) === "h5") {
      redirect(h5Host + "/user-center/focus");
    }
    // try {
    //   const {
    //     data: { data },
    //   } = await post({
    //     url: "/webapi/anchor/getAttentAnchors",
    //     req,
    //     data: { page: 1, size: PAGE_SIZE },
    //   });
    //   const list = data.list.map((item) => {
    //     let live = item.anchor.live;
    //     if (live) return live;
    //     return {
    //       thumb: item.anchor.avatar,
    //       living: !!live,
    //       title: item.anchor.nick_name + this.$t("uc-focus.live-room"),
    //       anchor: item.anchor,
    //       hot: 0,
    //       anchorid: item.anchor.id,

    //     };
    //   });
    //   return {
    //     list,
    //     totalCount: data.total_count,
    //   };
    // } catch (e) {
    //   if (req) {
    //     req.ctx.cookies.set("token");
    //     req.ctx.cookies.set("uid");
    //     redirect("/");
    //   }
    // }
  },
  middleware: "login-check",
  name: "focus",
  components: {
    UserCenterWrap,
    LiveItem,
    CenterCommon
  },
  data() {
    return {
      list: [],
      totalCount: 0,
      page: 1,
      focusName: "取消关注"
    };
  },
  methods: {
    changePage(page) {
      this.page = page;
      this.getList();
    },
    jionRoom(item) {
      this.$router.push({
        path: `/liveMatchesTwo/${item.anchorid}`
      });
    },
    getList() {
      post({
        url: "/api/anchor/getAttentAnchors",
        data: { page: this.page, size: PAGE_SIZE }
      }).then(({ data: { data } }) => {
        if (!data.list) {
          this.list = [];
          this.totalCount = 0;
          return;
        }
        this.list = data.list;
        this.totalCount = data.total_count;
      });
    },
    toggleFocus(id, type = 0) {
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: id,
          type: type
        }
      }).then(({ data: { data } }) => {
        this.page = 0;
        this.getList();
        console.log(data);
      });
    },
    cancleFocus(item) {
      post({
        url: "/api/anchor/attentAnchor",
        data: { anchorid: item.anchorid }
      }).then(({ data: { data } }) => {
        console.log(data, "---");
        this.$message.success("取消关注成功");
        this.getList();
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped lang="stylus">
@import '../../assets/variable.styl';

.focus-list {
  position: relative;
  min-height: 100%;
  padding-top:16px;
  padding-left:40px;
  padding-right: 25px;
  .title{
      font-size: 18px;
      color: #333333;
      font-weight: 700;
      position:relative;
      width:72px;
      text-align: center;
      z-index:2;
  }
  .focus_num{
    margin-top: 40px;
    margin-bottom: 24px;
    font-size: 16px;
    color: #333333;
    font-weight: 700;
  }
  .focus_c{
    display: flex;
    flex-wrap: wrap;
    li{
      width: 294px;
      height: 72px;
      background: #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.1);
      border-radius: 8px;
      margin-right: 15px;
      margin-bottom: 16px;
      overflow: hidden;
      display: flex;
      >img{
        width:72px;
        height:72px;
        cursor pointer
      }
      >div{
        display: flex;
        justify-content: space-between;
        padding-right: 16px;
        padding-left: 16px;
        align-items: center;
        flex:1;
        .left{
          font-size: 16px;
          color: #333333;
          font-weight: 700;
        }
        .right{
          width: 88px;
          height: 24px;
          background: #F7F7F7;
          border: 1px solid #F0F0F0;
          border-radius: 12px;
          font-size: 14px;
          color: #666666;
          text-align: center;
          line-height: 24px;
          cursor: pointer;
        }
      }
    }
  }

    .title:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: -3px;
      width:100%
      height:6px;
      background:#26d99d;
      border-radius: 35px;
      z-index:-1;
    }
    .no-data {
        height: 300px;
        font-size: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img{
          width 280px
          height 180px
        }
      }

  // .focus-item {
  //   background-color: #ffffff;
  //   box-shadow: 2px 2px 10px 0px rgba(1, 26, 13, 0.1);
  // }

  .information {
    padding: 56px 122px 60px 111px;
    height: 240px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    display: none;

    .avator {
      width: 122px;
      height: 122px;
      background-color: #dddddd;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: flex-end;

      span {
        font-size: 12px;
        color: #fff;
        height: 20px;
        background-color: #676767;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .right_content {
      flex: 1;
      height: 122px;
      margin-left: 23px;

      .first_line {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .left {
          font-size: 14px;
          color: #333;
        }

        .right {
          width: 60px;
          height: 30px;
          background-color: #fff;
          border-radius: 2px;
          border: solid 1px #d9bc88;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: #d9bc88;
          cursor: pointer;
        }
      }

      .second_line {
        display: flex;
        justify-content: space-between;
        margin-top: 31px;

        .left {
          font-size: 14px;
          color: #333;

          .live_name {
            margin-top: 20px;
          }
        }

        .right {
          display: flex;
          justify-content: space-between;
          flex: 1;
          margin-left: 67px;

          .add_bank {
            width: 144px;
            height: 58px;
            border-radius: 3px;
            border: solid 1px #999999;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #666;

            .el-icon-plus {
              font-size: 14px;
            }

            span {
              margin-left: 5px;
              color: #666;
            }
          }

          .bank {
            padding: 10px 13px 11px 8px;
            box-sizing: border-box;
            width: 144px;
            height: 58px;
            background-image: linear-gradient(
              90deg,
              #58c0ab 0%,
              #47aba0 50%,
              #359594 100%
            ), linear-gradient(
              #8ebcb3,
              #8ebcb3
            );
            background-blend-mode: normal, normal;
            border-radius: 3px;
            color: #fff;

            .bank_info {
              font-size: 12px;
              display: flex;
              justify-content: space-between;
              // padding: 10px 13px 11px 8px;
            }

            .bank_num {
              margin-top: 8px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .information_bottom {
    position: relative;
    display: none;
    .pagination_bottom {
      position: absolute;
      bottom: 33px;
      left: 50%;
      transform: translateX(-50%);

      /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fff;
        border: solid 1px #1c8c7a;
        color: #1c8c7a;
        box-sizing: border-box;
      }

      /deep/ .el-pagination.is-background .el-pager li {
        border: solid 1px #cccccc;
        color: #666;
        background-color: #fff;
        box-sizing: border-box;
      }

      /deep/ .el-pagination.is-background .btn-prev, /deep/ .el-pagination.is-background .btn-next {
        background-color: #fff;
        border: solid 1px #cccccc;
      }
    }

    .text_img {
      width: 130px;
      height: 33px;
      background: url('../../assets/img/user-center/arrow.png') no-repeat;
      background-size: 100% 100%;
      background-position: 0px 0px;
      position: relative;
      padding-bottom: 5px;
      left: -4px;
      background-blend-mode: normal, normal;
      // box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.11);
      line-height: 33px;
      color: #fff;
      font-size: 16px;
      margin-bottom: 9px;
      font-weight: 600;
      text-indent: 26px;
    }

    .detail_list {
      height: calc(100% - 130px);
      padding-top: 22px;
      padding-left: 26px
      border-top: 1px solid #eee;
      .no-data {
        height: 100%;
        font-size: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .detail_ul {
        height: 100%
        .detail_li {
          width: 328px;
          height: 68px;
          margin-right: 12px;
          border-radius: 3px;
          border: 1px solid #ccc;
          box-sizing: border-box;
          padding: 15px 18px 13px 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          float: left;
          // div {
          //   display: inline-block;
          // }

          .left {
            font-size: 0;
            flex-shrink: 0;
            margin-right: 8px;
            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
          }

          .middle {
            flex: 1
            .top_text {
              font-size: 14px;
              color: #333;
              font-family: 'PingFangSC-Semibold';
            }

            .bottom_text {
              color: #999;
              margin-top: 11px;
              font-family: 'PingFangSC-Semibold';
            }
          }

          .right {
            flex-shrink: 0;
            width: 70px;
            height: 26px;
            background-color: #ffffff;
            border-radius: 3px;
            border: solid 1px #ccc;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ccc;
            box-sizing: border-box;
            cursor: pointer;
          }

          .right:hover {
            border: solid 1px #1c8c7a;
            color: #1c8c7a;
          }
        }
        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  .pagination {
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: center;

    ::v-deep {
      .el-pagination {
        .el-pager li {
          width: 40px;
          height: 40px;
          line-height: 40px;
          border-radius: 5px;
          border: 1px solid #CCCCCC;
          color: #999999;
          background-color: #fff;

          &.more {
            border: none;
          }

          &.active {
            border: none;
            color: #fff;
            background-color: $theme-color;
          }
        }

        .btn-prev, .btn-next {
          background-color: #fff;
        }

        span:not([class*=suffix]) {
          height: 40px;
          line-height: 40px;
        }
      }
    }
  }

  @media only screen and (max-width: 1406px) {
  }
}
</style>
